export default __webpack_public_path__ + "static/media/cloud-upload-error.aa7d01d8.webp";